import css from './upcomingMaintenanceEventWidget.module.css'
import { CSSProperties, useEffect, useRef, useState } from 'react'
import calendarApi from '@/pages/Calendar/calendar.api'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import timeUtils from '@/utils/time.utils'
import { IMaintenanceEvent } from '@/pages/Calendar/calendar.types'
import MaintenanceEventListItem from './components/MaintenanceEventListItem'
import { Virtuoso } from 'react-virtuoso'
import { useNavigate } from 'react-router-dom'
import urls from '@/navigation/urls'
import SkeletonMaintenanceEventList from './components/SkeletonMaintenanceEventList'
import { IUser } from '@/pages/Users/users.types'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'

interface IProps {
  userId?: IUser['id']
  loading?: boolean
  titleStyle?: CSSProperties
  periodInDays?: number
}

const UpcomingMaintenanceEventWidget = ({ periodInDays = 30, ...props }: IProps) => {
  const [maintenanceEvent, setMaintenanceEvent] = useState<IMaintenanceEvent[]>([])
  const { wait, loading: maintenanceEventLoading } = useHttpLoader()
  const virtuosoRef = useRef()
  const navigate = useNavigate()

  useEffect(() => {
    if (props.loading) return
    const todayDate = new Date()
    todayDate.setHours(0)

    wait(
      calendarApi.getMaintenancePlansAllEquipment({
        date_lte: timeUtils.addDays(todayDate, periodInDays).toISOString(),
        date_gte: todayDate.toISOString(),
        userId: props.userId,
      }),
      (resp) => {
        if (resp.status === 'success') {
          setMaintenanceEvent(resp.body.filter((event) => event.type !== 'COMPLETED_MAINTENANCE'))
        }
      }
    )
  }, [props.userId])

  const onHandleClick = (date: Date) => {
    navigate({
      pathname: urls.calendar,
      search: `?date=${encodeURIComponent(date.toISOString())}`,
    })
  }

  const renderContent = () => {
    if (maintenanceEventLoading || props.loading) return <SkeletonMaintenanceEventList />

    if (!maintenanceEvent.length) {
      return (
        <div className="flex-lines center height100 width100">
          <EmptyPlaceholder inscription={`В ближайший месяц \n нет запланированных ТО`} />
        </div>
      )
    }

    return (
      <Virtuoso
        ref={virtuosoRef}
        style={{ height: '100%', width: '100%', scrollbarWidth: 'thin' }}
        totalCount={maintenanceEvent.length}
        itemContent={(index) => (
          <MaintenanceEventListItem maintenanceEvent={maintenanceEvent[index]} onClick={onHandleClick} />
        )}
      />
    )
  }

  return (
    <div className={css.wrapper}>
      <h2 style={{ padding: '6px 20px', ...(props.titleStyle ?? {}) }} className="text-heading-4">
        ТО — ближайшие события
      </h2>
      {renderContent()}
    </div>
  )
}

export default UpcomingMaintenanceEventWidget
